import React from 'react';
import PropTypes from 'prop-types';
import { memoize, isObject } from 'underscore';
import stringify from 'json-stable-stringify';
import { ReactObservable } from '@bingads-webui-react/react-observable';
import { withScope } from '@bingads-webui-react/scope-service';
import { getEntityFromScope } from '@bingads-webui/edm-campaign';
import { Observable } from '@bingads-webui-universal/observable';

const observableGetter = memoize(
  escapeResult => (
    new Observable((observer) => {
      observer.next(escapeResult);
      return () => { };
    })),

  escapeResult => (isObject(escapeResult) ? stringify(escapeResult) : escapeResult)
);

function CampaignODataImpl({
  scope,
  call,
  escapeHatch,
  fallback,
  onError,
  children,
  // This parameter is only used for testing purposes
  testRef,
}) {
  if (testRef) {
    // eslint-disable-next-line no-param-reassign
    testRef.current = { children };
  }

  const {
    currentCustomer,
    currentAccount,
    currentCampaign,
    currentAdGroup,
    currentEntity,
  } = getEntityFromScope(scope);

  const escapeResult = escapeHatch({
    currentCustomer,
    currentAccount,
    currentCampaign,
    currentAdGroup,
    currentEntity,
  });

  if (escapeResult !== undefined) {
    const observable = observableGetter(escapeResult);

    return (
      <ReactObservable
        observable={observable}
        fallback={fallback}
        onError={onError}
      >
        {children}
      </ReactObservable>
    );
  }

  return (
    <ReactObservable
      observable={call({
        currentCustomer,
        currentAccount,
        currentCampaign,
        currentAdGroup,
        currentEntity,
      })}
      fallback={fallback}
      onError={onError}
    >
      {children}
    </ReactObservable>
  );
}

CampaignODataImpl.propTypes = {
  scope: PropTypes.shape({
    values: PropTypes.object,
  }).isRequired,
  call: PropTypes.func.isRequired,
  escapeHatch: PropTypes.func,
  fallback: PropTypes.element.isRequired,
  onError: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
};

CampaignODataImpl.defaultProps = {
  escapeHatch: () => (undefined),
};

export const CampaignOData = withScope(CampaignODataImpl);
